export default {
  "welcome": {
    "welcome-to": "Welcome to",
    "one-philly": "Youn Philly,",
    "united-city": "Yon vil ini!",
  },
  "city-offices": {
    "city-offices-title": "Biwo vil",
    "city-offices-text-1": "Biwo vil yo louvri pou èdtan biznis regilye. Gen kèk sèvis yo te ofri sou entènèt oswa pa randevou. Pou aprann plis, ",
    "city-offices-text-2": "tcheke avèk depatman enterè ou.",
    "city-offices-closure-text": "",
    "trash-title": "Fatra & resiklaj",
    "trash-text-1": "Koleksyon fatra ak resiklaj yo sou yon orè jou ferye. Mete materyèl soti yon sèl jou dèyè jou regilye ou.",
    "trash-text-2": "Pou aprann plis, ",
    "trash-text-3": "tcheke orè jou ferye a.",
    "trash-closure-text": "",
  },
  "services": {
    "trash": "Jwenn jou fatra ou",
    "bill": "Peye yon bòdwo",
    "jobs": "Eksplore travay vil",
    "property": "Rechèch pou yon pwopriyete",
    "taxes": "Dosye epi peye taks nan vil",
    "recycle": "Resikle fèy tonbe",
    "visit": "Vizite yon moun ki enkarre",
    "license": "Jwenn yon lisans",
    "popular-services": "Sèvis popilè",
    "jump-to-all-services": "Sote nan tout sèvis",
    "services-by-topic": "Sèvis pa sijè",
    "see-all-services": "Gade tout sèvis",
    "alerts": "Enskri pou alèt ijans",
  },
  "tools": {
    "parks-finder": "Pak ak chèche rekreyasyon",
    "contracts": "Mwaye kontra",
    "school-time-activity": "Chèche aktivite soti nan lekòl la",
    "food-meal": "Chèche manje ak repa gratis",
    "atlas": "Atlas",
    "primary": "Chèche swen prensipal",
    "eclipse": "eklips",
    "mail-vote-remind": "Lapòs nan rapèl vòt",
    "street-smart": "StreetSmartPHL",
    "commonly-used-tools": "Zouti souvan itilize",
    "see-all-tools": "Gade tout zouti",
  },
  "news": {
    "featured-news": "Nouvèl ki tap",
    "see-all-news": "Gade tout nouvèl",
  },
  "311": {
    "report-311": "Ede fè Philadelphia pi an sekirite, pi pwòp, greenest gwo vil la nan nasyon an. Rapòte anpil vid, grafiti, oto abandone, ak plis ankò nan Philly311.",
    "report-problem": "RAPÒTE YON PWOBLÈM",
    "track-request": "SWIV YON DEMANN",
    "ask-question": "POZE YON KESYON",
  },
  "stay-connected": {
    "stay-connected": "Rete konekte",
    "sign-up-email": "Enskri pou dènye kouryèll soti nan vil la nan Philadelphia",
    "sign-up": "Enskripsyon",
  },
  "footer": {
    "elected-officials": "Ofisyèl eli",
    "mayor": "Majistra",
    "city-council": "Konsèy vil",
    "courts": "Tribinal",
    "district-attorney": "Avoka Distri",
    "city-controller": "Kontwolè vil",
    "sheriff": "Sherif",
    "city-commissioners": "Komisyonè vil",
    "register-wills": "Enskri nan testaman",
    "open-govt": "Louvri gouvènman",
    "code-charter": "Kòd & Charter Philadelphia",
    "city-records": "Dosye vil",
    "city-agency-regs": "Règleman ajans vil",
    "executive-orders": "Lòd egzekitif",
    "honesty-govt": "Onètete nan gouvènman",
    "voting-elections": "Vòt & eleksyon",
    "open-data": "Done louvri",
    "org-chart": "Tablo òganizasyon vil",
    "explore-phila": "Eksplore Philadelphia",
    "visit-phila": "Vizite Philadelphia",
  },
  "clean-green": {
    "clean-green": "Netwaye ak vèt ",
    "clean-green-statement": "Vil nou an ap rasanble ansanm pou fè Philly pi an sekirite, pi pwòp, ak greenest gwo vil nan nasyon an, ak opòtinite ekonomik pou tout. Swiv estrateji nan citywide ki nan abòde bon jan kalite nan pwoblèm lavi nan chak katye.",
    "blocks-swept": "Blòk baleye",
    "abandoned-autos": "Otos abandone retire",
    "properties-cleaned": "Pwopriyete netwaye ak sele",
    "graffiti-removed": "Grafiti retire",
    "see-all-clean-green": "WÈ TOUT PWÒP E VÈT",
  },
  "mayor": {
    "mayor-details": "Cherelle L. Parker se majistra a 100yèm nan Philadelphia ak premye fanm ki kenbe pozisyon sa a nan 341 ane. Yon rezidan tout lavi nan vil la, li nan angaje nan batay chak jou pou Philadelphians.",
    "learn-more": "Aprann plis",
  },
  "city-council": {
    "city-council": "Konsèy vil",
    "district-council-member": "Manm Konsèy Distri",
    "council-member-al":  "Manm Konsèy At-Large",
    "council-president": "Prezidan Konsèy",
    "dep-majority-whip": "Depite Majorite Fwèt",
    "majority-whip": "Majorite fwèt",
    "minority-leader": "Lidè minorite",
    "minority-whip": "Fwèt minorite",
    "majority-leader": "Lidè Majorite",
  }, 
  "philly-stat-360": {
    "ps360": "Philly State 360",
    "data-subheader": "Vire done nan aksyon pou kominote nou yo.",
  },
};